module.exports = __webpack_public_path__ + "img/tank.6df511f3.svg";